"use client";

import dynamic from "next/dynamic";
import { FloatingAgentProvider } from "./FloatingAgentProvider";
import { ErrorBoundary } from "react-error-boundary";
import { logger } from "@utilities/logger";
import { useTranslations } from "next-intl";

const FloatingAgent = dynamic(() => import("./FloatingAgent").then(mod => mod.FloatingAgent));

export function FloatingAgentWrapper(props: React.ComponentPropsWithoutRef<typeof FloatingAgent>) {
  return (
    <ErrorBoundary
      fallback={<FloatingAgentErrorBoundaryFallback />}
      onError={error => {
        logger.warn("FloatingAgent ErrorBoundary caught error:", error);
      }}
    >
      <FloatingAgentProvider>
        <FloatingAgent {...props} />
      </FloatingAgentProvider>
    </ErrorBoundary>
  );
}

function FloatingAgentErrorBoundaryFallback() {
  const t = useTranslations("ClientKeys.FloatingAgent");

  return (
    <button
      className='tw-fixed tw-bottom-4 tw-right-4 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-gap-x-2.5 tw-py-2.5 tw-pl-2.5 tw-pr-4.5 tw-text-left tw-outline-none focus-visible:tw-outline-focus'
      style={{ boxShadow: "0 0 0 1px rgb(0 0 0 / 0.05), 0 6px 16px rgb(78 50 23 / 0.04)" }}
      onClick={() => window.location.reload()}
    >
      <div className='tw-size-9 tw-bg-cream tw-rounded-full tw-flex-none tw-flex tw-items-center tw-justify-center'>
        <svg viewBox='0 0 24 24' aria-hidden className='tw-size-5 tw-text-gray-600'>
          <path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.636 3.258c1.066-1.793 3.662-1.793 4.728 0l7.484 12.586c1.09 1.833-.232 4.156-2.364 4.156H4.516c-2.133 0-3.454-2.323-2.364-4.156zM12 8a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 12 8m1 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0'
          />
        </svg>
      </div>
      <div>
        <div className='tw-type-sm sm:tw-type-base tw-text-black'>{t("error_boundary_title")}</div>
        <div className='tw-mt-1.5 sm:tw-mt-2 tw-type-2xs tw-text-gray-500'>{t("error_boundary_description")}</div>
      </div>
    </button>
  );
}
